module.exports = __webpack_public_path__ + "img/johnston-eco-logo.62b26ff2.jpg";